import { render, staticRenderFns } from "./WtContainer.vue?vue&type=template&id=5d7c0a06&scoped=true"
import script from "./WtContainer.vue?vue&type=script&lang=js"
export * from "./WtContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7c0a06",
  null
  
)

export default component.exports